<template>
  <TopGradientBlockLayout>
<!--    <template v-slot:top v-if="!currentUserIsWatcher">-->
<!--      <BaseButton v-if="!formBlock.open"-->
<!--                  theme="red" class="w-91 mr-12"-->
<!--                  @click="openForm('bank')">-->
<!--        {{ $t('addBank') }}-->
<!--      </BaseButton>-->
<!--      <BaseButton v-if="!formBlock.open"-->
<!--                  theme="red" class="w-91"-->
<!--                  @click="openForm('payment-system')">-->
<!--        {{ $t('addPaymentSystem') }}-->
<!--      </BaseButton>-->
<!--      <template v-if="formBlock.open">-->
<!--        <BankIntegrationForm v-if="formBlock.type === 'bank'"-->
<!--                             @connect="openConnectModal($event)"-->
<!--                             @cancel="formBlock.open = false;"/>-->
<!--        <PaymentSystemIntegrationForm v-if="formBlock.type === 'payment-system'"-->
<!--                                      @connect="openConnectModal($event)"-->
<!--                                      @cancel="formBlock.open = false;"/>-->
<!--      </template>-->
<!--    </template>-->
<!--    <BankIntegrationTip/>-->
    <BanksIntegrationsUnavailableTip/>
    <BanksIntegrationsList :providers="banksProviders"
                           :disable-buttons="disableButtons"
                           class="mb-12"
                           @edit="editConnection = $event"
                           @refresh="refreshConnectionProvider($event)"/>
    <PaymentsIntegrationsList :providers="paymentSystemsProviders"
                              :disable-buttons="disableButtons"
                              @edit="editConnection = $event"
                              @refresh="refreshConnectionProvider($event)"/>
    <transition name="modal">
      <SaltEdgeModal v-if="!!saltEdgeLink"
                     :salt-edge-link="saltEdgeLink"
                     @close="handleCloseSaltEdge"/>
      <RedirectModal v-if="!!redirectLink"
                     :redirect-link="redirectLink"
                     @close="redirectLink = null"/>
      <ConnectionEditModal v-if="!!editConnection"
                           :connection="editConnection"
                           @close="editConnection = null"
                           @closeOnSave="closeConnectionModal"/>
    </transition>
  </TopGradientBlockLayout>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {bank} from "@/utilities/bank_types";
import BaseButton from "@/components/UI/BaseButton";
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import BankIntegrationForm from "@/components/cabinet/SpaceSettings/BanksIntegrations/BanksIntegrationsForm";
import BankIntegrationTip from "@/components/cabinet/SpaceSettings/BanksIntegrations/BanksIntegrationsTip";
import ConnectionEditModal
  from "@/components/cabinet/SpaceSettings/BanksIntegrations/ConnectionEditModal";
import SaltEdgeModal from "@/components/cabinet/SpaceSettings/BanksIntegrations/SaltEdgeModal";
import PaymentSystemIntegrationForm
  from "@/components/cabinet/SpaceSettings/BanksIntegrations/PaymentSystemIntegrationForm";
import BanksIntegrationsList from "@/components/cabinet/SpaceSettings/BanksIntegrations/BanksIntegrationsList";
import PaymentsIntegrationsList from "@/components/cabinet/SpaceSettings/BanksIntegrations/PaymentsIntegrationsList";
import RedirectModal from "@/components/cabinet/SpaceSettings/BanksIntegrations/RedirectModal";
import BanksIntegrationsUnavailableTip
  from "@/components/cabinet/SpaceSettings/BanksIntegrations/BanksIntegrationsUnavailableTip";

export default {
  name: "TheBanksIntegrations",
  components: {
    BanksIntegrationsUnavailableTip,
    RedirectModal,
    PaymentsIntegrationsList,
    BanksIntegrationsList,
    PaymentSystemIntegrationForm,
    SaltEdgeModal,
    ConnectionEditModal,
    BankIntegrationTip, BankIntegrationForm, BaseButton, TopGradientBlockLayout
  },
  data() {
    return {
      formBlock: {
        type: '',
        open: false
      },
      editConnection: null,
      disableButtons: false,
      saltEdgeLink: null,
      redirectLink: null
    }
  },
  computed: {
    ...mapGetters('space/banks', ['banksProviders', 'paymentSystemsProviders']),
    ...mapGetters('space', ['spaceInfo', 'currentUserIsWatcher']),
  },
  methods: {
    ...mapActions('space/banks', ['refreshProvider']),
    async fetchMainData() {
      try {
        await Promise.all([
          this.$store.dispatch('space/accounts/getAccounts'),
          this.$store.dispatch('space/accounts/getAccountGroups'),
          this.$store.dispatch('space/banks/fetchBanksList'),
          this.$store.dispatch('space/banks/fetchProviders')
        ]);
      } catch (e) {
        throw e;
      }
    },
    openConnectModal({link, connection}) {
      this.formBlock.open = false;
      if (connection.connect_mode === bank.connectModes.MODAL) {
        this.saltEdgeLink = link;
      }
      if (connection.connect_mode === bank.connectModes.NEW_WINDOW) {
        this.redirectLink = link;
      }
    },
    async handleCloseSaltEdge() {
      this.saltEdgeLink = null;
      await this.$store.dispatch('space/accounts/getAccounts');
      await this.$store.dispatch('space/banks/fetchProviders');
    },
    async closeConnectionModal() {
      this.editConnection = null;
      await this.$store.dispatch('space/accounts/getAccounts');
      await this.$store.dispatch('space/banks/fetchProviders');
    },
    openForm(type) {
      this.formBlock.type = type;
      this.formBlock.open = true;
    },
    async refreshConnectionProvider(connection) {
      try {
        this.disableButtons = true;
        const res = await this.refreshProvider({space_id: this.spaceInfo.id, connection_id: connection.id})

        if (res.body.success) {
          if (connection.bank.connect_mode === bank.connectModes.MODAL) {
            this.saltEdgeLink = res.body.data;
          }
          if (connection.bank.connect_mode === bank.connectModes.NEW_WINDOW) {
            this.redirectLink = res.body.data;
          }
        } else {
          console.log(res.body);
          this.$toasted.error('Ошибка');
        }
      } catch (err) {
        console.log(err);
        this.$toasted.error('Ошибка');
      } finally {
        this.disableButtons = false;
      }
    }
  },
  async created() {
    await this.fetchMainData()
  },
  i18n: {
    messages: {
      en: {
        addBank: 'Add bank',
        addPaymentSystem: 'Add payment system',
      },
      ru: {
        addBank: 'Добавить банк',
        addPaymentSystem: 'Добавить платежную систему',
      }
    }
  }
}
</script>